import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

/**
 * Property notes — four kinds, one calm card (owner, 2026-09-02: the old
 * version was four label/value pairs interleaved with four full-width blue
 * buttons, each opening a modal for a one-line edit). Each note is a tile that
 * edits IN PLACE: Edit turns the text into a textarea, Save writes it, Cancel
 * puts it back. No modals.
 */
const KINDS = [
    { key: 'permanent_notes', title: 'Permanent', url: (id) => `/api/properties/${id}/permanent-note`, body: (v) => ({ permanent_notes: v || null }) },
    { key: 'dissapearing_note', title: 'Next cleaning', url: (id) => `/api/properties/${id}/note`, body: (v) => ({ dissapearing_note: v || null }) },
    { key: 'warehouse_note', title: 'Warehouse', url: (id) => `/api/properties/${id}/warehouse-note`, body: (v) => ({ warehouse_note: v || null }) },
    { key: 'scheduling_note', title: 'Scheduling', url: (id) => `/api/properties/${id}/scheduling-note`, body: (v) => ({ scheduling_note: v || null }) },
];

function Notes({ property, propertyId, updateNotes }) {
    const [editing, setEditing] = useState(null);     // key of the tile being edited
    const [draft, setDraft] = useState('');
    const [saving, setSaving] = useState(false);

    const startEdit = (kind) => {
        setEditing(kind.key);
        setDraft(property[kind.key] || '');
    };

    const save = async (kind) => {
        setSaving(true);
        try {
            const res = await axios.put(kind.url(propertyId), kind.body(draft.trim()));
            if (res.status === 200) {
                updateNotes(res.data);
                toast.success(`${kind.title} note saved`);
                setEditing(null);
            }
        } catch (e) {
            console.error('Error updating note:', e);
            toast.error('Could not save the note');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="dp-card pd-notes">
            <h2>Notes</h2>
            <div className="pn-tiles">
                {KINDS.map((kind) => {
                    const value = property[kind.key];
                    const isEditing = editing === kind.key;
                    return (
                        <div key={kind.key} className={`pn-tile ${isEditing ? 'is-editing' : ''}`}>
                            <div className="pn-tile-head">
                                <span className="pn-tile-title">{kind.title}</span>
                                {!isEditing && (
                                    <button type="button" className="pn-edit" onClick={() => startEdit(kind)}>
                                        {value ? 'Edit' : 'Add'}
                                    </button>
                                )}
                            </div>
                            {isEditing ? (
                                <>
                                    <textarea
                                        className="pn-textarea"
                                        value={draft}
                                        autoFocus
                                        rows={4}
                                        onChange={(e) => setDraft(e.target.value)}
                                        placeholder={`Write the ${kind.title.toLowerCase()} note…`}
                                    />
                                    <div className="pn-actions">
                                        <button type="button" className="pn-btn" onClick={() => setEditing(null)} disabled={saving}>
                                            Cancel
                                        </button>
                                        <button type="button" className="pn-btn pn-btn--save" onClick={() => save(kind)} disabled={saving}>
                                            {saving ? 'Saving…' : 'Save'}
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <div className={`pn-text ${value ? '' : 'pn-text--empty'}`}>
                                    {value || 'No note'}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Notes;
